import React from 'react'
import {
  GridColumn as Column,
  Grid,
  GridPageChangeEvent,
  GridSortChangeEvent,
} from '@progress/kendo-react-grid'
import { PageData } from 'api/Pagination/Types'
import { AdjustmentTransactionDto } from 'api/Transaction/Types/AdjustmentTransactionDto'
import { Loading } from 'components/Loading'
import { TableWithExport } from 'utils/table/withExport'

import walletsTransactionAccountColumns from '../../../Transactions/walletsTAColumn'

import '../TradingAccount.scss'

import { Pagination } from 'api/Pagination/Types/Pagination'
import { DispatchProps, GridState } from 'features/DataGrid/hooks/useGridState'
import { pageableSettings } from 'store/grid/grid.slice'

interface Props {
  adjustmentTransactions: PageData<AdjustmentTransactionDto[]> | undefined
  isLoading: boolean
  gridState: GridState
  gridActions: DispatchProps
}

const TradingAccountTransactionDetailsTable: React.FC<Props> = ({
  adjustmentTransactions,
  isLoading,
  gridState,
  gridActions,
}) => {
  const handleGridSortChange = async (event: GridSortChangeEvent) => {
    gridActions.setGridFilters({
      sort: event.sort,
    })
  }

  const handlePageChange = (event: GridPageChangeEvent) => {
    const { skip, take } = event.page
    const pagination = new Pagination({
      skip,
      recordsPerPage: take,
    })

    const pageIndex = !event.nativeEvent ? 1 : pagination.getPageIndex()

    gridActions.setGridFilters({
      skip: event.page.skip,
      take: event.page.take,
      pageSize: event.page.take,
      pageIndex,
    })
  }

  return (
    <Loading isLoading={isLoading}>
      {adjustmentTransactions && (
        <TableWithExport data={adjustmentTransactions.items || []}>
          <Grid
            resizable
            sortable={{
              allowUnsort: true,
              mode: 'multiple',
            }}
            take={gridState.take}
            skip={gridState.skip}
            sort={gridState.sort}
            total={adjustmentTransactions.totalResults}
            data={adjustmentTransactions.items}
            onSortChange={handleGridSortChange}
            onPageChange={handlePageChange}
            pageable={pageableSettings}
            style={{ zIndex: 0 }}
          >
            {walletsTransactionAccountColumns.map((column, index) => (
              <Column
                key={index}
                field={column.field}
                title={column.title}
                filter={column.filter}
                sortable={column.sortable}
                headerCell={column.headerCell}
                cell={column.cell}
                children={column.children}
                className={column.className}
                width={column.width}
                minResizableWidth={column.minResizableWidth}
              />
            ))}
          </Grid>
        </TableWithExport>
      )}
    </Loading>
  )
}

export default TradingAccountTransactionDetailsTable
